import { Controller } from "react-hook-form";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import {
  AdditionalFormFieldProps,
  PhoneNumberFieldProps,
} from "../common-types";
import { PhoneNumberFieldStyled } from "./phone-number-field.style";
import { Typography } from "@mui/material";

const PhoneNumberFormField: React.FC<
  PhoneNumberFieldProps & AdditionalFormFieldProps
> = (props) => {
  const { control, name, label, defaultValue } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { ref, value, ...field }, fieldState: { error } }) => (
        <PhoneNumberFieldStyled className="field-wrapper">
          {label && (
            <Typography className="field-label">{label}</Typography>
          )}
          <PhoneInput
            {...field}
            value={value}
            inputProps={{
              ref,
            }}
            country={"us"}
            onlyCountries={['us']}
            countryCodeEditable={false}
            disableDropdown={true}
          />
        </PhoneNumberFieldStyled>
      )}
    />
  );
};

export default PhoneNumberFormField;
